import React, { Component } from 'react';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Button from '../Button';
import useStyles from './styles';

interface State {
  hasError?: boolean;
}

const ErrorFallback = () => {
  const styles = useStyles();

  const onReload = () => {
    window.location.reload();
  };

  const onGoHome = () => {
    window.location.href = '/';
  };

  return (
    <div className={styles.content}>
      <ErrorOutlineIcon className={styles.icon} />
      <span className={styles.title}>Something Went Wrong</span>
      <p className={styles.desc}>
        The app ran into an unexpected error. Reloading the page usually
        fixes it.
      </p>
      <div className={styles.actions}>
        <Button className="btn-secondary" label="Go Home" onClick={onGoHome} />
        <Button className="btn-primary" label="Reload Page" onClick={onReload} />
      </div>
    </div>
  );
};

class ErrorBoundary extends Component<any, State> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error: any, errorInfo: React.ErrorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    console.error('Error stack:', error.stack);
    console.error('Component stack:', errorInfo.componentStack);
    this.setState({ hasError: true });
  }

  render() {
    if (this.state.hasError) {
      return <ErrorFallback />;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
